export function useRemoteAsset () {

  function getStorageAsset(name){
    return `/storage/${name}`
  }

  return {
    getStorageAsset
  }
}
